export default __webpack_public_path__ + "static/media/858_2.200a7806.jpg";